<div class="posterCard">
    <img [src]="show.poster" alt="">
    
    <div class="downloadButton" [ngClass]="{disabled: show.disabled}" (click)="addToCalendar()" (mouseenter)="onOver($event)" (mouseleave)="onOut($event)" #btn>
        <div *ngIf="!show.disabled" class="pls">+</div>
        <div *ngIf="!show.disabled" class="downlText">CALENDAR</div>
        <div *ngIf="show.disabled" class="downlText">COMING SOON</div>
    </div>
</div>